import axios from "axios";

export class CategoriesService {
  public async listCategories(): Promise<any[]> {
    const response = await axios.get("/v1/categories/");
    return response.data;
  }
}
